const LOCATION_ERROR_COPY = {
  location_denied: 'Location permission is turned off. Please allow location access and try again.',
  location_unavailable: 'We could not access your location at the moment. Please try again.',
  location_timeout: 'Location took too long to load. Please retry.',
  location_unsupported: 'Your browser does not support location discovery.',
  location_failed: 'We could not detect your location right now. Please retry.',
};

const LocationPromptCard = ({ isLocating = false, locationError = '', onRequestLocation }) => {
  const hasError = Boolean(locationError);
  const description = hasError
    ? LOCATION_ERROR_COPY[locationError] || LOCATION_ERROR_COPY.location_failed
    : 'Enable location to discover cricket activity near you.';

  return (
    <section className="nearby-hero-card card border-0 shadow-sm">
      <div className="card-body p-4 p-lg-5">
        <span className="badge bg-primary-subtle text-primary-emphasis mb-3">Nearby discovery</span>
        <h1 className="h3 mb-2">Find cricket around you</h1>
        <p className="text-muted mb-4">{description}</p>
        <button
          type="button"
          className={`btn ${hasError ? 'btn-outline-primary' : 'btn-primary'} btn-lg`}
          onClick={onRequestLocation}
          disabled={isLocating}
        >
          {isLocating ? 'Finding your location…' : 'Use My Location'}
        </button>
      </div>
    </section>
  );
};

export default LocationPromptCard;
